//AWS CONFIGS
const GQL_END_POINT = import.meta.env.CLIENT_GQL_ENDPOINT;
const GQL_API_KEY = import.meta.env.CLIENT_GQL_API_KEY;
const AWS_REGION = import.meta.env.CLIENT_AWS_REGION;
const USER_POOL_ID = import.meta.env.CLIENT_USER_POOL_ID;

export { GQL_END_POINT, GQL_API_KEY, AWS_REGION, USER_POOL_ID };
